import * as React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';

const ProductReviewNoItem: React.FunctionComponent = () => {
    const { translate } = useTranslationHook();
    return (
        <React.Fragment>
            <h3>{translate('There are no reviews for this product yet.', { ns: 'article-detail' })}</h3>
            <p>{translate('Write the first review!', { ns: 'article-detail' })}</p>
        </React.Fragment>
    );
}

export default ProductReviewNoItem;
